import { apiClient } from '../apiClient';
import { API_ENDPOINTS, createApiUrl, ServiceType } from 'src/contstant/apiEndpoints';
import type {
  GetAuditInsightsRequest,
  GetAuditInsightsResponse,
} from 'src/types/starlight/AuditInsights';

/**
 * Reads the stored audit insight from Starlight.
 *
 * REST rather than a generated client because Starlight publishes no TypeScript client.
 * Session cookies travel via `apiClient`'s `withCredentials`; the Starlight Midway session
 * is warmed alongside Helios and Orbit at sign-in.
 */
export const auditInsightsService = {
  get: ({ businessUnitId, auditId, language }: GetAuditInsightsRequest) => {
    return apiClient.get<GetAuditInsightsResponse>(
      ServiceType.STARLIGHT,
      createApiUrl(
        API_ENDPOINTS.STARLIGHT_SERVICE.AUDIT_INSIGHTS.GET(businessUnitId, auditId),
      ),
      language ? { language } : undefined,
    );
  },
};
